var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    enableBackground: "new 0 0 58 58",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M12.512,55.361c-0.205,0-0.41-0.063-0.583-0.189 c-0.305-0.222-0.458-0.598-0.394-0.968l3.062-17.849L1.631,23.72c-0.27-0.264-0.367-0.657-0.251-1.015 c0.117-0.358,0.427-0.62,0.801-0.674l17.917-2.604L28.113,3.19C28.279,2.851,28.624,2.637,29,2.637l0,0 c0.377,0,0.723,0.214,0.887,0.553L37.9,19.427l17.918,2.604c0.373,0.055,0.684,0.315,0.801,0.674 c0.115,0.358,0.021,0.752-0.25,1.015L43.402,36.359l3.061,17.847c0.063,0.37-0.089,0.746-0.393,0.968 c-0.305,0.225-0.711,0.254-1.045,0.076L29,46.822l-16.028,8.427C12.827,55.322,12.669,55.361,12.512,55.361z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite);
export default __webpack_public_path__ + "static/media/icon_favorite.f3a1baf377c517d9e6fb4465530170c8.svg";
export { ForwardRef as ReactComponent };